import React from 'react';

export default function Content({ className='', ...props }) {
  return (
    <div className="sm:w-screen-sm lg:w-screen-lg xl:w-screen-xl mx-auto">
      <div className={`p-5 ${className}`} {...props} />
    </div>
  );
}
